import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './redux/store'

import { ErrorBoundary } from "react-error-boundary";
import FallbackRender from 'client/Components/ErrorBoundary/FallbackRender'
import LogError from 'client/Components/ErrorBoundary/LogError/LogError'


const container = document.getElementById('root')



ReactDOM.render(
  <ErrorBoundary fallbackRender={FallbackRender} onError={LogError}>
     <Router>
       <Provider store={store}>
           <App />
       </Provider>
     </Router>
    </ErrorBoundary>,
  container
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
